import { createImage } from './utils';

const getCroppedImg = async (imageSrc, croppedAreaPixels) => {
  try {
    // Validasi properti croppedAreaPixels
    const { x, y, width, height } = croppedAreaPixels;
    if (typeof x !== 'number' || typeof y !== 'number' || typeof width !== 'number' || typeof height !== 'number') {
      throw new Error("croppedAreaPixels tidak memiliki properti yang diperlukan.");
    }

    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const maxSize = Math.max(image.width, image.height);
    const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

    canvas.width = safeArea;
    canvas.height = safeArea;

    ctx.drawImage(
      image,
      safeArea / 2 - image.width * 0.5,
      safeArea / 2 - image.height * 0.5
    );

    const data = ctx.getImageData(
      safeArea / 2 - image.width * 0.5 + x,
      safeArea / 2 - image.height * 0.5 + y,
      width,
      height
    );

    canvas.width = width;
    canvas.height = height;

    ctx.putImageData(data, 0, 0);

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, "image/jpeg");
    });
  } catch (error) {
    console.error("Error di getCroppedImg:", error);
    throw error;
  }
};

export default getCroppedImg;
